import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, auth } from "../lib/api";
import { Sparkle, Lock, EnvelopeSimple } from "@phosphor-icons/react";

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@likedigital.it");
  const [password, setPassword] = useState("AdminPass123!");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      auth.setSession(data.access_token, data.user);
      nav("/");
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Errore di accesso");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex w-1/2 bg-zinc-950 text-white p-12 flex-col justify-between">
        <div className="flex items-center gap-2">
          <Sparkle weight="fill" className="text-klein" size={28} />
          <span className="font-display font-extrabold text-xl">GARE MANAGER AI</span>
        </div>
        <div className="space-y-6">
          <h2 className="font-display text-5xl font-extrabold leading-none tracking-tighter">
            Vincere<br />gare pubbliche.<br /><span className="text-klein">Con intelligenza.</span>
          </h2>
          <p className="text-zinc-400 text-sm max-w-md leading-relaxed">
            Scouting multi-portale, analisi documentale AI, identificazione incumbent, redazione assistita
            della relazione tecnica, simulazione offerta economica.
            Conformita D.Lgs. 36/2023.
          </p>
          <div className="grid grid-cols-3 gap-4 max-w-md pt-6">
            <Metric label="Portali" value="20+" />
            <Metric label="Moduli AI" value="12" />
            <Metric label="Conformita" value="36/23" />
          </div>
        </div>
        <div className="text-xs text-zinc-500 font-mono">v1.0 / Like Digital S.r.l.</div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8 bg-zinc-50">
        <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="login-form">
          <div>
            <div className="label-up mb-2">Accesso piattaforma</div>
            <h1 className="font-display text-4xl font-extrabold tracking-tighter">Benvenuto.</h1>
            <p className="text-sm text-zinc-500 mt-2">Inserisci le credenziali. MFA in arrivo nelle prossime release.</p>
          </div>

          <div className="space-y-4">
            <div>
              <label className="label-up mb-1.5 block">Email</label>
              <div className="relative">
                <EnvelopeSimple size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
                <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-field pl-9" />
              </div>
            </div>
            <div>
              <label className="label-up mb-1.5 block">Password</label>
              <div className="relative">
                <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
                <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-field pl-9" />
              </div>
            </div>
          </div>

          {err && <div data-testid="login-error" className="text-sm text-red-600 border-l-2 border-red-500 pl-3 py-1">{err}</div>}

          <button data-testid="login-submit" type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? "Accesso in corso..." : "Accedi alla piattaforma"}
          </button>

          <div className="text-sm text-zinc-500 text-center">
            Nessun account? <Link to="/register" data-testid="link-register" className="text-klein font-medium hover:underline">Registrati</Link>
          </div>
        </form>
      </div>
    </div>
  );
}

function Metric({ label, value }) {
  return (
    <div className="border-l border-zinc-800 pl-3">
      <div className="font-display font-bold text-2xl">{value}</div>
      <div className="label-up text-zinc-500">{label}</div>
    </div>
  );
}
